import React from 'react';
import TruckContainerSvg from '../../../images/truck-container.svg';
import IconBase from './IconBase';

const TruckContainer = (props) => {
  return <IconBase svg={TruckContainerSvg} {...props} />;
};

export default TruckContainer;
